<script lang="ts">
	import Wordmark from '$lib/components/fragments/Wordmark.svelte';
	import { page } from '$app/state';
	import md from '$lib/utils/md';
	import { getCopy } from '$lib/lang/copy.svelte';

	const copy = $derived(getCopy().footer);

	const socials = [
		{
			title: 'LinkedIn',
			href: 'https://www.linkedin.com/company/vital-strategies/',
			icon: 'mdi:linkedin'
		},
		{
			title: 'Instagram',
			href: 'https://www.instagram.com/vitalstrategies/',
			icon: 'mdi:instagram'
		},
		{
			title: 'BlueSky',
			href: 'https://bsky.app/profile/vitalstrategies.org',
			icon: 'fa6-brands:bluesky'
		},
		{
			title: 'YouTube',
			href: 'https://www.youtube.com/vitalstrategiesmedia',
			icon: 'fa6-brands:youtube'
		}
	];
</script>

<div class="bg-blue-dark flex flex-col gap-6 px-4 py-8 text-white md:px-6">
	<a href={page.data.publisher_url} aria-current="page" class="logo-link w-inline-block w-36">
		<Wordmark />
	</a>
	<div class="subtitle-1 flex flex-wrap gap-x-8">
		{#each copy as { title, href } (`${title}${href}`)}
			<a {href} class="hover:text-yellow hover:underline">{title}</a>
		{/each}
	</div>

	<div class="flex w-full flex-wrap items-end justify-between gap-3">
		<div class="label text-xs">2025 Copyright, {page.data.publisher}</div>
		<div class="flex items-center gap-2">
			{#each socials as { title, href, icon } (title)}
				<a
					{href}
					target="_blank"
					class="h-fit transition-transform hover:scale-110"
					aria-label={title}
				>
					<iconify-icon {icon} class="h-5 text-2xl"></iconify-icon>
				</a>
			{/each}
		</div>
	</div>
</div>

<style lang="postcss">
	@reference '$lib/styles/app.css';

	a {
		@apply hover:underline;
	}
</style>
